module.exports = __webpack_public_path__ + "static/media/universityhover.68a7af2e.svg";